import React from 'react';
import { Box, Typography } from '@material-ui/core';
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline';
import ErrorOutline from '@material-ui/icons/ErrorOutline';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
import ReportProblemOutlined from '@material-ui/icons/ReportProblemOutlined';

type Severity = 'info' | 'success' | 'warning' | 'error';

const PALETTE: Record<Severity, { color: string; background: string; Icon: React.ComponentType<any> }> = {
    info: { color: '#00598f', background: '#e5f0fa', Icon: InfoOutlined },
    success: { color: '#0d7a3a', background: '#e3f5ea', Icon: CheckCircleOutline },
    warning: { color: '#8a5a00', background: '#fff3d6', Icon: ReportProblemOutlined },
    error: { color: '#a12828', background: '#fde8e8', Icon: ErrorOutline },
};

interface NoticeProps {
    severity: Severity;
    title?: React.ReactNode;
    children?: React.ReactNode;
    action?: React.ReactNode;
}

/** Lightweight Alert (@material-ui/lab is not a dependency). */
const Notice: React.FC<NoticeProps> = ({ severity, title, children, action }) => {
    const { color, background, Icon } = PALETTE[severity];
    return (
        <Box
            role={severity === 'error' || severity === 'warning' ? 'alert' : 'status'}
            display='flex'
            alignItems='flex-start'
            marginY={1}
            padding='10px 14px'
            borderRadius={6}
            style={{ background, color, borderLeft: `4px solid ${color}`, gap: 10 }}
        >
            <Icon fontSize='small' style={{ marginTop: 2 }} />
            <Box flex={1}>
                {title && (
                    <Typography variant='subtitle2' style={{ color }}>
                        {title}
                    </Typography>
                )}
                {children && (
                    <Typography variant='body2' component='div' style={{ color }}>
                        {children}
                    </Typography>
                )}
            </Box>
            {action}
        </Box>
    );
};

export default Notice;
